var map = {
	"./george_256.png": "1564",
	"./marple_256.png": "bb09",
	"./mulder_256.png": "495f",
	"./nico_256.png": "f3fd",
	"./olivia_256.png": "d3a4",
	"./poirot_256.png": "425d",
	"./scully_256.png": "c6e2",
	"./sherlock_256.png": "a309",
	"./walter_256.png": "5e95",
	"./watson_256.png": "29c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74e8";